import React from 'react';

function ContactUsSection() {
  const styles = {
    section: {
      width: '100%', maxWidth: 1920, minHeight: 960, position: 'relative', opacity: 1, overflow: 'hidden'
    },
    bgImage: {
      position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
      objectFit: 'cover', objectPosition: 'center', zIndex: 0, opacity: 1
    },
    overlay: {
      position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: 0.5
    },
    formWrap: {
      position: 'absolute', top: 0, left: 'clamp(0px, 8vw, 120px)', zIndex: 1,
      width: 'clamp(400px, 42vw, 680px)', maxWidth: 680,
      background: '#FFFFFF', opacity: 1,
      padding: '80px 48px 80px 48px', boxSizing: 'border-box',
      display: 'flex', flexDirection: 'column',
      borderTopRightRadius: 8, borderBottomRightRadius: 8,
      minHeight: 960, height: '100%'
    },
    headerBlock: { marginBottom: 24 },
    subheading: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#090909',
      margin: '0 0 12px 0'
    },
    dashLine: {
      width: 150, height: 0, borderTop: '2px solid #E73123', marginBottom: 16, flexShrink: 0
    },
    title: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, margin: 0, textTransform: 'uppercase', color: '#E73123'
    },
    label: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '16px', lineHeight: '28px',
      letterSpacing: 0, color: '#090909', margin: '0 0 8px 0', display: 'block'
    },
    intro: {
      fontFamily: 'Lato', fontWeight: 400, fontStyle: 'normal', fontSize: 16,
      lineHeight: '26px', letterSpacing: 0, color: '#838383', margin: '0 0 32px 0',
      maxWidth: 520
    },
    input: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '16px', width: '100%',
      padding: '16px', border: '1px solid #E0E0E0', borderRadius: 6,
      marginBottom: 0, boxSizing: 'border-box'
    },
    inputRow: {
      display: 'flex', gap: 16, marginBottom: 16
    },
    phoneWrap: {
      display: 'flex', gap: 8, flex: 1
    },
    phoneCode: {
      width: 80, padding: '16px 12px', border: '1px solid #E0E0E0',
      borderRadius: 6, fontFamily: 'Lato', fontSize: '16px', boxSizing: 'border-box'
    },
    textarea: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '16px', width: '100%',
      padding: '16px', border: '1px solid #E0E0E0', borderRadius: 6,
      minHeight: 120, resize: 'vertical', marginBottom: 0, boxSizing: 'border-box'
    },
    submitBtn: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '16px', padding: '16px 32px',
      background: '#E73123', color: '#FFFFFF', border: 'none', borderRadius: 6,
      cursor: 'pointer', width: 'fit-content', textTransform: 'uppercase', marginTop: 8
    },
  };

  return React.createElement('section', { id: 'contact', style: styles.section, className: 'contact-us-section' },
    React.createElement('img', {
      src: '/contactus.jpg',
      alt: '',
      style: styles.bgImage
    }),
    React.createElement('div', { style: styles.overlay }),
      React.createElement('div', { style: styles.formWrap, className: 'contact-form-wrap' },
      React.createElement('div', { style: styles.headerBlock },
        React.createElement('h2', { style: styles.subheading }, 'CONTACT US'),
        React.createElement('div', { style: styles.dashLine }),
        React.createElement('h3', { style: styles.title }, 'GET IN TOUCH')
      ),
      React.createElement('p', { style: Object.assign({}, styles.intro, { whiteSpace: 'pre-line' }) }, "Have a project in mind or need more information? Get\nin touch with our team and we'll respond promptly."),
      React.createElement('form', null,
        React.createElement('div', { style: { marginBottom: 16 } },
          React.createElement('label', { style: styles.label }, 'Full Name'),
          React.createElement('input', { type: 'text', placeholder: 'John Smith', style: Object.assign({}, styles.input, { marginBottom: 0 }), name: 'fullName' })
        ),
        React.createElement('div', { style: { marginBottom: 16 } },
          React.createElement('label', { style: styles.label }, 'Company Name'),
          React.createElement('input', { type: 'text', placeholder: 'Type here...', style: Object.assign({}, styles.input, { marginBottom: 0 }), name: 'company' })
        ),
        React.createElement('div', { style: styles.inputRow, className: 'contact-input-row' },
          React.createElement('div', { style: { flex: 1 }, className: 'contact-field' },
            React.createElement('label', { style: styles.label }, 'Email Address'),
            React.createElement('input', { type: 'email', placeholder: 'johnsmith88@gmail.com', style: Object.assign({}, styles.input, { marginBottom: 0 }), name: 'email' })
          ),
          React.createElement('div', { style: { flex: 1 }, className: 'contact-field' },
            React.createElement('label', { style: styles.label }, 'Phone Number'),
            React.createElement('div', { style: Object.assign({}, styles.phoneWrap, { marginBottom: 0 }), className: 'contact-phone-wrap' },
              React.createElement('select', { style: styles.phoneCode, name: 'countryCode' },
                React.createElement('option', { value: '+91' }, '+91'),
                React.createElement('option', { value: '+1' }, '+1'),
                React.createElement('option', { value: '+44' }, '+44')
              ),
              React.createElement('input', { type: 'tel', placeholder: '9854210326', style: Object.assign({}, styles.input, { flex: 1, marginBottom: 0 }) })
            )
          )
        ),
        React.createElement('div', { style: { marginBottom: 24 } },
          React.createElement('label', { style: styles.label }, 'Your Message'),
          React.createElement('textarea', { placeholder: 'Type here...', style: Object.assign({}, styles.textarea, { marginBottom: 0 }), name: 'message' })
        ),
        React.createElement('button', { type: 'submit', style: styles.submitBtn }, 'Send Now')
      )
    )
  );
}

export default ContactUsSection;
